export default __webpack_public_path__ + "static/latest-3-704cd5024e8a6489a529f532b5e69ed4.webp";